import { EmailIcon, WebAppIcon, MobileAppIcon, SmsIcon } from "./components/channelicons";

export const FLOW_WO = 0;
export const FLOW_PO = 1;

export const FLOWS = [
  {
    flow: FLOW_WO,
    label: "Work Order",
    description: "Notifications triggered by work order status changes.",
  },
  {
    flow: FLOW_PO,
    label: "Purchase Order",
    description: "Notifications triggered by purchase order events.",
  },
];

// `event` values are the numbers the backend matches on when it decides who to
// notify (see wo.service / po.service / technician.service). They are NOT list
// indexes — only the Email/WO list ever spelled them out before, while the rest
// relied on their array position. They are written out explicitly here so the
// rows can be reordered or extended without silently repointing a rule at a
// different event.
export const CHANNELS = [
  {
    type: 0,
    label: "Email",
    icon: EmailIcon,
    statuses: {
      [FLOW_WO]: [
        { name: "Requested", value: 9 },
        { name: "Issued (Service WO)", value: 0 },
        { name: "Issued (Quoted WO)", value: 6 },
        { name: "Issued (PM WO)", value: 7 },
        { name: "Issued (Parts Only WO)", value: 8 },
        { name: "Service Ticket Reviewed", value: 1 },
        { name: "Updated", value: 2 },
        { name: "Service Ticket Completed", value: 3 },
        { name: "Billed", value: 4 },
        { name: "Incomplete Service Ticket", value: 5 },
        // Fires from saveSignature when a submitted service ticket carries a
        // non-empty recommendation.
        { name: "Recommendation", value: 10 },
        // A customer signed a proposal on their quote request, or asked for a
        // revision of it.
        { name: "Proposal Accepted", value: 11 },
        { name: "Proposal Revision Requested", value: 12 },
      ],
      [FLOW_PO]: [
        { name: "Issued", value: 0 },
        { name: "Completed", value: 1 },
        { name: "Updated", value: 2 },
        { name: "Requested", value: 3 },
        { name: "Reimbursed PO Completed", value: 4 },
      ],
    },
  },
  {
    type: 1,
    label: "Web App",
    icon: WebAppIcon,
    statuses: {
      [FLOW_WO]: [
        { name: "Technician accepts WO assignment", value: 0 },
        { name: "Service Ticket Completed", value: 1 },
        { name: "Tech is 'Enroute'", value: 2 },
        { name: "Tech is 'Arrived'", value: 3 },
        { name: "Requested", value: 4 },
      ],
      [FLOW_PO]: [
        { name: "PO is requested from technician", value: 0 },
        { name: "PO receipt has been submitted", value: 1 },
      ],
    },
  },
  {
    type: 2,
    label: "Mobile App",
    icon: MobileAppIcon,
    statuses: {
      [FLOW_WO]: [{ name: "Issued", value: 0 }],
      [FLOW_PO]: [{ name: "Issued to a technician", value: 0 }],
    },
  },
  {
    type: 3,
    label: "SMS",
    icon: SmsIcon,
    statuses: {
      [FLOW_WO]: [
        { name: "Requested", value: 0 },
        { name: "Issued", value: 1 },
        { name: "Service Ticket Completed", value: 2 },
        { name: "Service Ticket Reviewed", value: 3 },
        { name: "Billed", value: 4 },
      ],
      [FLOW_PO]: [
        { name: "Requested", value: 0 },
        { name: "Issued", value: 1 },
        { name: "Completed", value: 2 },
      ],
    },
  },
];

export const getChannel = (type) => CHANNELS.find((channel) => channel.type === type) ?? CHANNELS[0];

export const ruleKey = (type, flow, event) => `${type}:${flow}:${event}`;
